/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IManageClaimsScope extends angular.IScope {
        model: models.ManageClaimsModel;
    }

    export class ManageClaimsController implements IController {
        scope: IManageClaimsScope;

        constructor(
            $scope: IManageClaimsScope,
            claimDefinitionService: services.ClaimDefinitionService,
            systemLevelService: services.SystemLevelService,
            deleteService: services.DeleteService,
            modalService: any) {
            this.scope = $scope;
            this.scope.model = new models.ManageClaimsModel(claimDefinitionService, systemLevelService, deleteService, modalService);
        }
    }
}

warsApp.registerController("ManageClaimsController", ["$scope", "claimDefinitionService", "systemLevelService", "deleteService", "ModalService"]);